import { useTheme } from '@automata/mui-theme';
import { PatternLines } from '@visx/pattern';

export const PATTERN_1_ID = 'pattern1';

const Pattern1 = (): JSX.Element => {
  const theme = useTheme();

  return (
    <PatternLines
      id={PATTERN_1_ID}
      height={4}
      width={4}
      stroke={theme.palette.primary.main}
      strokeWidth={2}
      orientation={['diagonal']}
    />
  );
};

export default Pattern1;
